import { render, staticRenderFns } from "./SectionIntroduction.vue?vue&type=template&id=d2c7f488&scoped=true&"
import script from "./SectionIntroduction.vue?vue&type=script&lang=js&"
export * from "./SectionIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./SectionIntroduction.vue?vue&type=style&index=0&id=d2c7f488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c7f488",
  null
  
)

export default component.exports